import { GetContractDocumentPayload } from "../../api/services/client/models";
import {
  isNotEmpty,
  validateApiParamValue,
  validateApiParamValueWithBlankSpace,
} from "../utils";
import { ClientTypeEnum } from "./common";
const CLIENT_MANAGEMENT = "/client/clientmanagement";
export const MDM_BASE_URL = "/mdm";
const PROGRAM_BASE_URL = "/program";
const USERS_BASE_URL = "/user";
const PROGRAM_TEMPLATE_BASE_URL = "/programtemplates";
const COMPATIBLE_PROGRAM_TEMPLATE_URL = "/compatibleprogramtemplates";
const MANAGE_USER_BASE_URL = "api/admin";
export const MS_GRAPH_BASE_URL = "https://graph.microsoft.com";
const SYSTEM_MESSAGE_BASE_URL = "/api/admin/systemmessages";

export const API_ENDPOINTS = {
  SITE_CORE_API: "/AdminApi/GetAdminPageDetails",
  SITE_CORE_REFERENCE_API: "/ReferenceServiceApi/GetReferenceData",
  SITE_CORE_P1_API: "/PageService/GetPageContent",
  REFERENCE_DATA_SEARCH: "/api/references/references/data/search",
  CLIENT_BASE_URL: CLIENT_MANAGEMENT,
  GET_CLIENT_LIST: "/clients/search",
  GET_COUNTRY_DROPDOWN_LIST: "/api/references/references/data/en-US/country",
  GET_COUNTRY_LIST_BY_PAGE: (pageType = "", operationType = "") =>
    `${MDM_BASE_URL}/countriesbypage?pageType=${validateApiParamValue(pageType)}&operationType=${validateApiParamValue(operationType)}`,
  GET_LANGUAGE_PREFERENCES_LIST: "/api/admin/CMSContent",
  POST_CLIENT: `${CLIENT_MANAGEMENT}/clients`,
  GET_STAFF_LIST_USERS: "/user/users",
  GET_COACH_STAFF_LIST: "/user/staff",
  POST_SAVE_FILTER: "/user/user/savedsearchfilters",
  GET_DELIVERY_OFFICES: "/api/references/ServiceOffice",
  GET_FEATURE_LIST: `${PROGRAM_BASE_URL}/featurelist`,
  CREATE_UPDATE_GENERIC_ACCOUNT: `${PROGRAM_BASE_URL}/genericAccounts`,
  GET_INDUSTRY_DROPDOWN_LIST: `${MDM_BASE_URL}/industries`,
  GET_DATE_FORMAT_MASTER_LIST: `${MDM_BASE_URL}/dateFormatMaster`,

  //manage user module api
  GET_USER_ROLES: `${MANAGE_USER_BASE_URL}/roles`,
  GET_SEARCH_USER_LIST: `/user/users/search`,
  GET_VERIFY_USER_EMAIL_ID_FROM_AD: (emailId = "") => `/v1.0/users/${emailId}`,
  GET_USER_LIST_FROM_AD: (emailAddress = "") =>
    `/user/adusers?emailAddress=${emailAddress}`,
  GET_USER_SERVICE_ACCOUNT_LIST: "/api/admin/ServiceAccount/Cronofy",
  GET_USER_TIMEZONE_LIST: "/api/references/references/data/en-US/timezone",
  CREATE_USER: "api/admin/UserDetail",
  GET_CRONOFY_TIMEZONE_LIST: (countryCode = "") =>
    `${MANAGE_USER_BASE_URL}/IANATimeZone/${validateApiParamValue(countryCode)}/Cronofy`,
  EDIT_USER: "api/admin/UserDetail",
  getUserListById(staffId: string): string {
    return `${MANAGE_USER_BASE_URL}/UserDetailsById/${validateApiParamValue(staffId)}`;
  },
  EXPORT_USER: `/user/users/export`,
  GET_USER_SERVICE_LIST_BY_COUNTRY_IDS: (countryCodes = "") =>
    `/mdm/officeList?countryCode=${validateApiParamValue(countryCodes)}`,

  //system message
  GET_SYSTEM_MESSAGE_LIST_BY_COUNTRY_IDS: (countryCode = "") =>
    `${SYSTEM_MESSAGE_BASE_URL}/country/${validateApiParamValue(countryCode)}`,
  GET_SYSTEM_MESSAGE_COUNTRY_LIST: `api/admin/country/languagecode`,
  CREATE_SYSTEM_MESSAGE: SYSTEM_MESSAGE_BASE_URL,
  DELETE_SYSTEM_MESSAGE: (messageId = "") =>
    `${SYSTEM_MESSAGE_BASE_URL}/${validateApiParamValue(messageId)}`,
  EDIT_SYSTEM_MESSAGE: (messageId = "") =>
    `${SYSTEM_MESSAGE_BASE_URL}/${validateApiParamValue(messageId)}`,
  VIEW_SYSTEM_MESSAGE: (messageId = "") =>
    `${SYSTEM_MESSAGE_BASE_URL}/${validateApiParamValue(messageId)}`,

  //program templates
  MDM_BASE_URL: "/mdm",
  GET_LINE_OF_BUSINESS: MDM_BASE_URL + "/lineofbusinesses",
  GET_GROUPED_LINE_OF_BUSINESS: MDM_BASE_URL + "/v2/lineOfBusinesses",
  GET_GROUPED_PROGRAM_TEMPLATES: MDM_BASE_URL + "/v2/programTemplates",
  GET_PROGRAM_FRAMEWORK: MDM_BASE_URL + "/programframeworks",
  GET_SOLUTION_CATEGORY: MDM_BASE_URL + "/solutioncategories",
  GET_SOLUTION_CATEGORY_LOB: MDM_BASE_URL + "/solutioncategorylobs",
  GET_SOLUTION_OFFERING: MDM_BASE_URL + "/solutionofferings",
  GET_PROGRAM_CLASS: MDM_BASE_URL + "/programclasses",
  GET_ACTIVITY_DELIVERABLES: MDM_BASE_URL + "/deliverables",
  CREATE_ACTIVITY: MDM_BASE_URL + "/activities",
  GET_PROGRAM_TEMPLATE_ACTIVITY_BY_ID: MDM_BASE_URL + "/activities",
  GET_PROGRAM_TEMPLATE_DELIVERABLE_BY_ID: MDM_BASE_URL + "/deliverables/search",
  POST_SAVE_PROGRAM_TEMPLATE: MDM_BASE_URL + "/programtemplates",
  GET_PROGRAM_TEMPLATE: MDM_BASE_URL + "/programtemplates/search",
  GET_SAVED_FILTERS: "/user/user/savedsearchfilters",
  DELETE_SAVED_FILTERS: "/user/user/savedsearchfilters",
  GET_PROGRAM_TEMPLATE_BY_ID: MDM_BASE_URL + "/programTemplates",
  UPDATE_PROGRAM_TEMPLATE: MDM_BASE_URL + "/programTemplates/",
  GET_PROGRAM_COACH_FUNCTION: MDM_BASE_URL + "/coachAssignmentFunctions",
  GET_GENERIC_ACCOUNTS: PROGRAM_BASE_URL + "/genericAccounts/search",
  //report apis
  PENDING_BILLING_REPORTS: PROGRAM_BASE_URL + "/pendingBillsSummary",
  NCBP_REPORT: PROGRAM_BASE_URL + "/ncbpReport",
  NOTIFICATION_STATUS_REPORTS: PROGRAM_BASE_URL + "/notificationStatusReport",
  EXPORT_NOTIFICATION_STATUS_REPORT:
    PROGRAM_BASE_URL + "/notificationStatusReport/export",
  OUTREACH_REPORTS: PROGRAM_BASE_URL + "/outreachListReport",
  EXPORT_OUTREACH_REPORT: PROGRAM_BASE_URL + "/outreachListReport/export",
  GET_ALL_MARKET_FOR_DELIVERY_OFFICES: `${MDM_BASE_URL}/marketsForLoggedInUser`,

  BULK_CREATE_PROGRAM_UPLOAD_SUBMIT:
    PROGRAM_BASE_URL + "/programs/bulkimport/submit",
  GET_BUSINESS_UNITS_BY_COUNTRY: (countryId: string) =>
    `${MDM_BASE_URL}/businessUnits?countryCode=${validateApiParamValue(countryId)}`,
  getCancelBulkProcess(bulkImportId: string): string {
    return `${PROGRAM_BASE_URL}/programs/bulkimport/${bulkImportId}`;
  },
  getBulkUploadStatusById(bulkImportId: string, category?: string): string {
    const baseUrl = `${PROGRAM_BASE_URL}/programs/bulkimportstatus/${validateApiParamValue(bulkImportId)}`;
    return category
      ? `${baseUrl}?category=${validateApiParamValue(category)}`
      : baseUrl;
  },
  GET_POWER_BI_REPORTS: (isUserSpecificList: boolean) =>
    MDM_BASE_URL + `/powerbireports?IsUserSpecific=${isUserSpecificList}`,
  REPORT_SEARCH_CATEGORY: MDM_BASE_URL + "/reportCategories",
  REPORT_SEARCH_TYPE: MDM_BASE_URL + "/reportTypes",
  GET_ALL_PROGRAM_TEMPLATES: MDM_BASE_URL + "/programTemplates",
  EXPORT_PENDING_BILLING_REPORT:
    PROGRAM_BASE_URL + "/pendingBillsSummary/export",
  EXPORT_NCBP_REPORT: PROGRAM_BASE_URL + "/ncbpReport/export",
  // compatible program template
  getCompatibleProgramTemplateListByCountry(
    templateId: string,
    countryId: string,
  ): string {
    return `${MDM_BASE_URL}${PROGRAM_TEMPLATE_BASE_URL}/${validateApiParamValue(templateId)}${COMPATIBLE_PROGRAM_TEMPLATE_URL}/${validateApiParamValue(countryId)}/`;
  },
  getCompatibleProgramTemplateList(templateId: string): string {
    return `${MDM_BASE_URL}${PROGRAM_TEMPLATE_BASE_URL}/${validateApiParamValue(templateId)}${COMPATIBLE_PROGRAM_TEMPLATE_URL}`;
  },
  addCompatibleProgramTemplate(templateId: string): string {
    return `${MDM_BASE_URL}${PROGRAM_TEMPLATE_BASE_URL}/${validateApiParamValue(templateId)}${COMPATIBLE_PROGRAM_TEMPLATE_URL}`;
  },
  deleteCompatibleProgramTemplate(
    templateId: string,
    compatibleTemplateId: string,
  ): string {
    return `${MDM_BASE_URL}${PROGRAM_TEMPLATE_BASE_URL}/${templateId}${COMPATIBLE_PROGRAM_TEMPLATE_URL}/${compatibleTemplateId}`;
  },
  UPLOAD_DOCUMENTS: "/shared/documents",
  getClientById(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${clientId}`;
  },
  getBillingDetailsAndConfigByClientId(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${clientId}/billingdetails`;
  },
  getDocumentById(documentId: string): string {
    return `/shared/documents/${documentId}`;
  },
  getHrBillingContactList(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${clientId}/contactlist`;
  },
  getClientAvailableContact(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${clientId}/availableContacts`;
  },
  addNewContact(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${clientId}/contacts`;
  },
  deleteContact(clientId: string, contactId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${clientId}/contacts/${contactId}`;
  },
  tagRemoveParentClient(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${clientId}`;
  },
  getUpdateClientContactById(clientId: string, contactId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${clientId}/contacts/${contactId}`;
  },
  getSearchActivity(programFrameWorkId: string): string {
    return `${MDM_BASE_URL}/programFrameworks/${programFrameWorkId}/activities`;
  },
  getClientHierarchyById(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${clientId}/heirarchy`;
  },
  updateClientDetailsById(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${clientId}`;
  },
  USER_PREFERRED_LANGUAGE: "/user/user/userpreferredlanguage",

  USERS_DETAILS_BY_ROLE: (countryCode?: string) => {
    const baseUrl = `/user/user/usersByRole`;
    return countryCode
      ? `${baseUrl}?countrycode=${validateApiParamValue(countryCode)}`
      : baseUrl;
  },

  getListOfActivitiesById(
    programTemplateId: string,
    programFrameWorkId: string,
  ): string {
    return `${MDM_BASE_URL}/activities?programTemplateId=${validateApiParamValue(programTemplateId)}&programFrameWorkId=${validateApiParamValue(programFrameWorkId)}`;
  },
  deleteActivityFromProgramTemplate(
    programTemplateId: string,
    activityId: string,
  ): string {
    return `${MDM_BASE_URL}/programTemplates/${programTemplateId}/activities/${activityId}`;
  },

  deleteDeliverableFromProgramTemplate(
    programTemplateId: string,
    deliverableId: string,
  ): string {
    return `${MDM_BASE_URL}/programTemplates/${programTemplateId}/deliverables/${deliverableId}`;
  },
  addClientSpecificContentResourcesAndProgramTemplates(
    clientId: string,
  ): string {
    return `${CLIENT_MANAGEMENT}/clients/${clientId}/resourceGroups`;
  },
  updateClientSpecificContent(resourceGroupId: string): string {
    return `${CLIENT_MANAGEMENT}/resourceGroups/${resourceGroupId}`;
  },
  getClientSpecificContent(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${clientId}/resourceGroups`;
  },
  deleteClientSpecificContent(clientResourceGroupId: string): string {
    return `${CLIENT_MANAGEMENT}/resourceGroups/${clientResourceGroupId}`;
  },
  getResourceByGroupId(resourceGroupId: string): string {
    return `${CLIENT_MANAGEMENT}/resourceGroups/${resourceGroupId}`;
  },
  updateActivityFromProgramTemplate(
    programTemplateId: string,
    activityId: string,
  ): string {
    return `${MDM_BASE_URL}/programTemplates/${programTemplateId}/activities/${activityId}`;
  },
  getDocumentListByClientId(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${clientId}/documents`;
  },
  getArchiveDocumentListByClientId(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${clientId}/documents/archive`;
  },
  addNewDeliverable(programTemplateId: string): string {
    return `${MDM_BASE_URL}/programTemplates/${validateApiParamValue(programTemplateId)}/deliverables`;
  },
  selectedDeliverable(programTemplateId: string): string {
    return `${MDM_BASE_URL}/programTemplates/${validateApiParamValue(programTemplateId)}/selecteddeliverables`;
  },
  GET_CLIENT_LIST_FOR_PROGRAM: CLIENT_MANAGEMENT + "/GetClientsList",
  GET_PROGRAM_TEMPLATE_LIST_FOR_PROGRAM: MDM_BASE_URL + "/programTemplates",
  // program
  CREATE_PROGRAM: PROGRAM_BASE_URL + "/programs",

  CREATE_PROJECT_KEY_DETAILS: PROGRAM_BASE_URL + "/projects",

  updateProgramDetailById(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${programId}`;
  },
  saveProgramStatus(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${programId}/programStatus`;
  },
  updateProgramStatus(programId: string, statusId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${programId}/programStatus/${statusId}`;
  },
  activateProgram(programId: string, nisParticipantId?: string): string {
    let url = `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/activation`;
    if (isNotEmpty(nisParticipantId)) {
      url += `?nisParticipantId=${validateApiParamValue(nisParticipantId)}`;
    }
    return url;
  },
  updateNextContactDate(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/nextcontactdate`;
  },
  getProgramDetailById(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/programDetails`;
  },
  getCompatibleProgramTemplates(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/compatibleProgramTemplates`;
  },
  getProgramTransfer(programId: string): string {
    return `${PROGRAM_BASE_URL}/program/${validateApiParamValue(programId)}/programTransfer`;
  },
  deleteTransferActivity(programId: string): string {
    return `${PROGRAM_BASE_URL}/program/${programId}/programTransfer`;
  },
  getDestinationPrograms(
    programId: string,
    queryParam: string,
    isCountry: boolean,
  ): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/destinationPrograms?${
      isCountry
        ? `countryCode=${validateApiParamValue(queryParam)}`
        : `programTemplateId=${validateApiParamValue(queryParam)}`
    }`;
  },
  getProgramStatusListById(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/programStatus`;
  },
  getPurchaseOrder(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${validateApiParamValue(clientId)}/purchaseOrders`;
  },
  getPurchaseOrderByClientWithActiveStatus(
    clientId: string,
    status: string,
  ): string {
    return `${CLIENT_MANAGEMENT}/clients/${validateApiParamValue(clientId)}/purchaseOrders?statusId=${validateApiParamValue(status)}`;
  },
  addPurchaseOrder(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${clientId}/purchaseOrders`;
  },
  getPurchaseOrderById(purchaseOrderId: string): string {
    return `${CLIENT_MANAGEMENT}/purchaseOrders/${purchaseOrderId}`;
  },
  reOpenPurchaseOrderById(purchaseOrderId: string): string {
    return `${CLIENT_MANAGEMENT}/purchaseOrders/${validateApiParamValue(purchaseOrderId)}/action`;
  },
  SEARCH_PROGRAM: PROGRAM_BASE_URL + "/programs/search",
  SEARCH_NIS_PARTICIPANTS: PROGRAM_BASE_URL + "/nisparticipants/search",
  SEARCH_GENERIC_ACCOUNT_PARTICIPANTS:
    PROGRAM_BASE_URL + "/genericAccountParticipants/search",
  SEARCH_ELIGIBLE_PROGRAM: PROGRAM_BASE_URL + "/eligiblePrograms/search",
  GET_PROGRAM_CLOSING_REASON_LIST: `${MDM_BASE_URL}${PROGRAM_TEMPLATE_BASE_URL}/programClosingReason`,
  getProgramPrimaryClosingReasonList(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${programId}/primaryClosingReason`;
  },
  getProgramSecondaryClosingReasonList(
    programId: string,
    primaryClosingId: string,
  ): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/secondaryClosingReason/${validateApiParamValue(primaryClosingId)}`;
  },
  getProgramClosingTimeToLandData(
    programId: string,
    landedDate: string,
  ): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/timetoland?landedDate=${validateApiParamValue(landedDate)}`;
  },

  getProgramTemplateDeliverablesById(
    deliverableId: string,
    templateId: string,
  ): string {
    return `${MDM_BASE_URL}/deliverables/${validateApiParamValue(deliverableId)}?programTemplateId=${validateApiParamValue(templateId)}`;
  },
  getListOfDeliverables(
    programTemplateId: string,
    programFrameWorkId: string,
  ): string {
    return `${MDM_BASE_URL}/deliverables/search?programTemplateId=${validateApiParamValue(programTemplateId)}&programFrameWorkId=${validateApiParamValue(programFrameWorkId)}`;
  },
  updateDeliverable(programTemplateId: string, deliverableId: string): string {
    return `${MDM_BASE_URL}/programTemplates/${validateApiParamValue(programTemplateId)}/deliverables/${validateApiParamValue(deliverableId)}`;
  },
  getCountriesByGeoScope(geoScopeId: string): string {
    return `${MDM_BASE_URL}/countries?geoScopeId=${geoScopeId}`;
  },
  inheritDocuments: `${CLIENT_MANAGEMENT}/documents/inherit`,
  searchDocuments: `${CLIENT_MANAGEMENT}/clients/documents/search`,
  uploadContractDocumentsById(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${clientId}/contractDocuments`;
  },
  uploadOtherDocumentsById(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${clientId}/otherDocuments`;
  },
  updateContractDocument(documentId: string): string {
    return `${CLIENT_MANAGEMENT}/contractDocuments/${documentId}`;
  },
  updateOtherDocument(documentId: string): string {
    return `${CLIENT_MANAGEMENT}/otherClientDocuments/${documentId}`;
  },
  getLocalClientRelationshipOwnerList(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${validateApiParamValue(clientId)}/localClientRelationshipOwnerList`;
  },
  getProjectManagerList(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${validateApiParamValue(clientId)}/projectManagerList`;
  },
  getProjectCoordinatorList(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${validateApiParamValue(clientId)}/projectCoordinatorList`;
  },

  deleteContractDocument(documentId: string): string {
    return `${CLIENT_MANAGEMENT}/contractDocuments/${documentId}`;
  },
  updateStatusContractDocument(documentId: string): string {
    return `${CLIENT_MANAGEMENT}/contractDocuments/${documentId}/status`;
  },
  deleteOtherDocument(documentId: string): string {
    return `${CLIENT_MANAGEMENT}/otherClientDocuments/${documentId}`;
  },
  updateStatusOtherDocument(documentId: string): string {
    return `${CLIENT_MANAGEMENT}/otherClientDocuments/${documentId}/status`;
  },
  archiveStatusOtherDocument(documentId: string): string {
    return `${CLIENT_MANAGEMENT}/otherClientDocuments/${documentId}/archive`;
  },
  archiveStatusContractDocument(documentId: string): string {
    return `${CLIENT_MANAGEMENT}/contractDocuments/${documentId}/archive`;
  },
  unmapContractDocuments: `${CLIENT_MANAGEMENT}/clientContractDocuments/unmap`,
  unmapOtherDocuments: `${CLIENT_MANAGEMENT}/clientOtherDocuments/unmap`,
  getPurchaseOrderTransactions(purchaseOrderId: string): string {
    return `${CLIENT_MANAGEMENT}/purchaseOrders/${purchaseOrderId}/transactions`;
  },
  postPurchaseOrderTransactions(purchaseOrderId: string): string {
    return `${CLIENT_MANAGEMENT}/purchaseOrders/${purchaseOrderId}/transactions`;
  },
  saveParticipantInformationById(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/candidates`;
  },
  updateParticipantInformationById(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/candidatedetails`;
  },
  getContractDocumentById(documentId: string): string {
    return `${CLIENT_MANAGEMENT}/contractDocuments/${documentId}`;
  },
  getOtherClientDocumentById(documentId: string): string {
    return `${CLIENT_MANAGEMENT}/otherClientDocuments/${documentId}`;
  },
  getParticipantInfoByProgramId(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/candidates`;
  },
  getSalesOfficeByLocalClientRelationshipOwnerId(
    localClientRelationshipOwnerId: string,
  ): string {
    return `user/users/${validateApiParamValue(localClientRelationshipOwnerId)}/salesOffice`;
  },
  deletePurchaseOrder(purchaseOrderId: string): string {
    return `${CLIENT_MANAGEMENT}/purchaseOrders/${purchaseOrderId}`;
  },
  getClientActivities(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${validateApiParamValue(clientId)}/activities`;
  },
  getClientDeliverables(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${validateApiParamValue(clientId)}/deliverables`;
  },
  GET_BEST_MATCH_PREFERENCES: MDM_BASE_URL + "/bestMatchPreferences",
  GET_SPECIAL_ASSIGNMENTS: MDM_BASE_URL + "/specialassignments",
  GET_CURRENCIES: MDM_BASE_URL + "/currencies",
  GET_TECHNICALSKILLS: MDM_BASE_URL + "/technicalskills",
  GET_SKILLS: MDM_BASE_URL + "/skills",
  GET_TARGET_INDUSTRIES: MDM_BASE_URL + "/targetindustries",

  getParticipantsList(name: string): string {
    return `${PROGRAM_BASE_URL}/programs/GetParticipantsList?name=${validateApiParamValueWithBlankSpace(name)}`;
  },
  getActivityTypeListByProgramId(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/activityTypes`;
  },
  getActivityTypeListByProjectId(projectId: string): string {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/activityTypes`;
  },
  getModalityListById(programId: string, activityTypeKey: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/activityTypes/${activityTypeKey}/modalities`;
  },
  getModalityListByProjectId(
    projectId: string,
    activityTypeKey: string,
  ): string {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/activityTypes/${activityTypeKey}/modalities`;
  },
  getTopicList(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/topics`;
  },
  getTopicsByActivityIdAndProjectId(
    activityId: string,
    projectId: string,
  ): string {
    return `${MDM_BASE_URL}/activity/${validateApiParamValue(activityId)}/topics?projectId=${validateApiParamValue(projectId)}`;
  },
  saveActivityForProgram(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/activities`;
  },
  saveActivityForProject(projectId: string): string {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/timelineActivities`;
  },
  getActivitiesByProgramId(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/activities`;
  },
  getActivitiesByCandidateIdForGenericAccount(candidateId: string): string {
    return `${PROGRAM_BASE_URL}/nextCandidate/${validateApiParamValue(candidateId)}/activities`;
  },
  getActivitiesByProjectId(projectId: string): string {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/timelineActivities`;
  },
  getSessionAndEventsByProgramId(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/sessionsAndEvents`;
  },
  getSessionAndEventsByCandidateIdForGenericAccount(
    candidateId: string,
  ): string {
    return `${PROGRAM_BASE_URL}/nextCandidate/${validateApiParamValue(candidateId)}/sessionsAndEvents`;
  },
  updateActivityForProgram(participantActivityTimeLineId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${participantActivityTimeLineId}/candidatesActivityTimelines`;
  },
  deleteActivityFromTimeline(participantActivityTimeLineId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${participantActivityTimeLineId}/candidatesActivityTimelines`;
  },
  deleteNISActivityFromTimeline(timelineActivityId: string): string {
    return `${PROGRAM_BASE_URL}/nisTimelineActivities/${timelineActivityId}`;
  },
  GET_ACTIVITY_LIST: `${CLIENT_MANAGEMENT}/activityList`,
  GET_TOPIC_LIST: `${CLIENT_MANAGEMENT}/topicList`,
  getAlternateDisplayName: (clientId: string) =>
    `${CLIENT_MANAGEMENT}/clients/${clientId}/saleOffices`,

  getOfficeByClientId: (clientId: string) =>
    `${CLIENT_MANAGEMENT}/clients/${validateApiParamValue(clientId)}/offices`,

  // bulk create program apis
  BULK_CREATE_PROGRAM_DOWNLOAD_SMART_TEMPLATE: (clientId = ""): string => {
    return `${PROGRAM_BASE_URL}/programs/downloadtemplates/${validateApiParamValue(clientId)}`;
  },
  BULK_CREATE_PROGRAM_DOWNLOAD_REPORT: (bulkImportId = ""): string => {
    return `${PROGRAM_BASE_URL}/programs/bulkfeedbackreport/${bulkImportId}`;
  },
  BULK_EDIT_PROGRAM_DOWNLOAD_SMART_TEMPLATE: `${PROGRAM_BASE_URL}/programs/downloadedittemplate`,

  //bulk activity apis
  GET_BULK_PARTICIPANT_COMPATIBLE_PROGRAM_TEMPLATES: `${PROGRAM_BASE_URL}/programs/bulkParticipantTransfer/compatibleProgramTemplates`,
  SAVE_BULK_PARTICIPANT_TRANSFER: `${PROGRAM_BASE_URL}/program/bulkParticipantTransfer/bulkTransfer`,
  GET_BULK_PARTICIPANT_TRANSFER_DESTINATION_PROGRAM_DETAIL: `${PROGRAM_BASE_URL}/program/bulkParticipantTransfer/destinationPrograms`,
  GET_NEXT_LANGUAGES: `${MDM_BASE_URL}/nextLanguages`,
  //manage bulk Process apis
  GET_BULK_PROCESS_BY_STATUS: `${PROGRAM_BASE_URL}/programs/bulkimport/manage`,

  //bulk activity apis
  GET_BULK_PARTICIPANT_LIST: `${PROGRAM_BASE_URL}/program/bulkParticipantsSearch`,
  GET_BULK_SUMMARY_PARTICIPANT_LIST: `${PROGRAM_BASE_URL}/program/bulkParticipantsInsert`,
  getCoachListByProgramId: (programId: string) =>
    `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/coaches`,
  getActivityTypeListForBulkInsertActivity: `${MDM_BASE_URL}/bulkinsert/activityTypes`,
  getModalityListForBulkInsertActivity(activityTypeId: string): string {
    return `${MDM_BASE_URL}/bulkinsert/activityTypes/${validateApiParamValue(activityTypeId)}/modalities`;
  },
  getTopicListForBulkInsertActivity: `${MDM_BASE_URL}/bulkinsert/topics`,
  GET_USER_COACHES: "/user/users/coaches",
  GET_MY_MEETINGS: `/user/users/myMeetings`,

  getGenericAccountById(genericAccountId: string): string {
    return `${PROGRAM_BASE_URL}/genericAccounts/${genericAccountId}`;
  },
  getGenericAccountKeyDetails(genericAccountId: string): string {
    return `/genericAccounts/${genericAccountId}/keyDetails`;
  },
  getUpdateGenericAccountParticipantById(participantId: string): string {
    return `${PROGRAM_BASE_URL}/genericAccountParticipants/${participantId}`;
  },
  deleteGenericAccount(genericAccountId: string): string {
    return `${PROGRAM_BASE_URL}/genericAccounts/${genericAccountId}`;
  },
  GET_CURRENCIES_BY_COUNTRY: (countryId: string) =>
    MDM_BASE_URL +
    "/currencies?countrycode=" +
    validateApiParamValue(countryId),

  getProgramFeesAndExpenseById(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${programId}/expenses`;
  },
  TAX_TYPES: MDM_BASE_URL + "/taxTypes",
  getProgramFeeDetailsByProgramId(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/fee`;
  },

  saveProgramFeeDetailsByProgramId(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/fee`;
  },
  updateProgramFeeDetailsByProgramId(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/fee`;
  },
  getClientBillingDetails(
    clientId: string,
    programTemplateId: string,
    lineOfBusinessId?: string,
  ): string {
    const baseUrl = `${CLIENT_MANAGEMENT}/clientBillingDetails?clientId=${validateApiParamValue(clientId)}&programTemplateId=${validateApiParamValue(programTemplateId)}`;
    return lineOfBusinessId
      ? `${baseUrl}&lineOfBusinessId=${validateApiParamValue(lineOfBusinessId)}`
      : baseUrl;
  },
  GET_TIMEZONE_LIST: (languageCode: string) =>
    `/api/references/references/data/${validateApiParamValue(languageCode)}/timezone`,

  GET_FEE_TYPE: () => MDM_BASE_URL + "/feeTypes",

  GET_INCURRED_BY_USERS: () => "user/incurredByUsers",

  GET_EXPENSE_CATEGORY: () => MDM_BASE_URL + "/expenseCategories",

  GET_EXPENSE_TYPE: (expenseCategoryId: string) =>
    `${MDM_BASE_URL}/expenseTypes?expenseCategoryId=${validateApiParamValue(expenseCategoryId)}`,

  getPaymentTerms: () => `${MDM_BASE_URL}/paymentTerms`,

  createOrEditProgramFeeOrExpense(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/programExpense`;
  },

  getInvoiceById(invoiceId: string): string {
    return `${PROGRAM_BASE_URL}/invoices/${invoiceId}`;
  },

  getInvoicesByProgramId(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/invoices`;
  },

  getRevenueSplitForProgramByInvoiceId(invoiceId: string): string {
    return `${PROGRAM_BASE_URL}/programInvoices/${validateApiParamValue(invoiceId)}/revenueSplit`;
  },

  updateRevenueSplitForProgramByInvoiceId(invoiceId: string): string {
    return `${PROGRAM_BASE_URL}/programInvoices/${validateApiParamValue(invoiceId)}/revenueSplit`;
  },

  getRevenueSplitForProjectByInvoiceId(invoiceId: string): string {
    return `${PROGRAM_BASE_URL}/projectInvoices/${validateApiParamValue(invoiceId)}/revenueSplit`;
  },

  getMigratedRevenueSplitForProjectByInvoiceId(invoiceId: string): string {
    return `${PROGRAM_BASE_URL}/projectInvoices/${validateApiParamValue(invoiceId)}/migratedRevenueSplit`;
  },

  updateRevenueSplitForProjectByInvoiceId(invoiceId: string): string {
    return `${PROGRAM_BASE_URL}/projectInvoices/${validateApiParamValue(invoiceId)}/revenueSplit`;
  },

  getInvoiceExportDataByProgramId(invoiceId: string): string {
    return `${PROGRAM_BASE_URL}/programInvoices/${validateApiParamValue(invoiceId)}/export`;
  },
  getInvoiceExportDataByProjectId(invoiceId: string): string {
    return `${PROGRAM_BASE_URL}/projectInvoices/${validateApiParamValue(invoiceId)}/export`;
  },
  downloadInvoiceByProgramId(invoiceId: string): string {
    return `${PROGRAM_BASE_URL}/programInvoices/${validateApiParamValue(invoiceId)}/download`;
  },
  downloadInvoiceByProjectId(invoiceId: string): string {
    return `${PROGRAM_BASE_URL}/projectInvoices/${validateApiParamValue(invoiceId)}/download`;
  },

  createInvoiceByProgramId(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/invoice`;
  },
  getProgramExpense: (expenseId: string): string => {
    return `${PROGRAM_BASE_URL}/ProgramExpenses/${expenseId}`;
  },
  getProgramExpenseById(programExpenseId: string): string {
    return `${PROGRAM_BASE_URL}/ProgramExpenses/${programExpenseId}`;
  },
  getProgramClosureData(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/closuredata`;
  },
  // MDM Activity APIs
  GET_MDM_SEARCH_ACTIVITY: `${MDM_BASE_URL}/searchactivities/activities`,
  MDM_ADD_ACTIVITY: `${MDM_BASE_URL}/addactivity/activity`,
  MDM_EDIT_ACTIVITY: `${MDM_BASE_URL}/activity/`,
  MDM_UPDATE_ACTIVITY: (activityId = ""): string => {
    return `${MDM_BASE_URL}/activity/${activityId}`;
  },
  MDM_VIEW_ACTIVITY: (activityId = ""): string => {
    return `${MDM_BASE_URL}/activity/${validateApiParamValue(activityId)}`;
  },
  GET_PROGRAM_TEMPLATE_BY_LOB_ID: MDM_BASE_URL + "/programTemplates",
  GET_MDM_EXISTING_TOPICS: `${MDM_BASE_URL}/topics/master`,
  MDM_VIEW_TOPIC: `${MDM_BASE_URL}/topic`,
  MDM_UPDATE_TOPIC: `${MDM_BASE_URL}/topic`,
  // MDM Office APIs
  CREATE_MDM_OFFICE: `${MDM_BASE_URL}/offices`,
  GET_MARKETS: `${MDM_BASE_URL}/markets`,
  GET_MARKET_SEARCH: `${MDM_BASE_URL}/marketsearch`,
  GET_INVOICE_TEMPLATES: `${MDM_BASE_URL}/templates`,
  GET_OFFICE_LIST: `${MDM_BASE_URL}/officeList`,
  GET_SEARCH_REGION: `${MDM_BASE_URL}/regions/search`,
  GET_MDM_OFFICES_SEARCH: `${MDM_BASE_URL}/offices/search`,
  GET_LANGUAGES: `${MDM_BASE_URL}/languages`,
  GET_COACH_METRICS: `${PROGRAM_BASE_URL}/coachMetrics`,
  GET_CURRENCY_CONVERSION: `${PROGRAM_BASE_URL}/programExpenses/currencyConversion`,
  /**
   * Get invoicing languages for a client or program.
   * @param clientId - ClientId for which list of languages need to be retrieved
   * @param programId - ProgramId for which list of languages needs to be retrieved
   * @returns API endpoint string
   */
  getInvoicingLanguages: (clientId?: string, programId?: string): string => {
    if (isNotEmpty(clientId))
      return `${MDM_BASE_URL}/invoicingLanguages?clientId=${validateApiParamValue(clientId)}`;
    if (isNotEmpty(programId))
      return `${MDM_BASE_URL}/invoicingLanguages?programId=${validateApiParamValue(programId)}`;
    return `${MDM_BASE_URL}/invoicingLanguages`;
  },

  getMdmOfficeById: (officeId: string): string => {
    return `${MDM_BASE_URL}/offices/${officeId}`;
  },
  updateMdmOfficeById: (officeId: string): string => {
    return `${MDM_BASE_URL}/offices/${officeId}`;
  },
  deleteMdmOffice(officeId: string): string {
    return `${MDM_BASE_URL}/offices/${officeId}`;
  },
  completeParticipantTransfer(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/completeparticipanttransfer`;
  },
  getReportTypesByCategoryId(categoryId: string): string {
    return `${MDM_BASE_URL}/reportTypes?reportCategoryId=${categoryId}`;
  },
  getManageParticipantsMetricsCount: (programId: string): string => {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/participantMetrics`;
  },
  GET_CLIENT_LIST_AUTOCOMPLETE: (
    keyword: string,
    isActiveClientOnly: boolean,
    excludeNCBPClient: boolean,
    clientType?: ClientTypeEnum,
  ) => {
    let urlParams = `keyword=${validateApiParamValueWithBlankSpace(keyword)}`;
    if (isActiveClientOnly) {
      urlParams = `${urlParams}&isActiveClient=${isActiveClientOnly}`;
    }
    if (excludeNCBPClient) {
      urlParams = `${urlParams}&excludeNCBPClient=${excludeNCBPClient}`;
    }
    if (clientType) {
      urlParams = `${urlParams}&clientType=${clientType}`;
    }
    return `${CLIENT_MANAGEMENT}/GetClientsList?${urlParams}`;
  },
  SEARCH_PROJECT: PROGRAM_BASE_URL + "/projects/search",
  GET_PROJECT_KEY_DETAILS: (projectId = ""): string => {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}`;
  },
  UPDATE_PROJECT_KEY_DETAILS: (projectId = ""): string => {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}`;
  },
  GET_PROJECT_LIST_AUTOCOMPLETE: (keyword = "", clientId: string) =>
    `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(clientId)}/getprojectlist?keyword=${validateApiParamValueWithBlankSpace(keyword)}`,

  saveProjectPrimaryDetailById(projectId: string): string {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/primarydetails`; // need to be correct from BE site
  },

  updateProjectPrimaryDetailById(projectId: string): string {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/primarydetails`; // need to be correct from BE site
  },

  saveProjectFeeDetails(projectId: string): string {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/fee`;
  },

  GET_PROJECT_PRIMARY_DETAILS: (projectId: string): string =>
    `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/primarydetails`,

  getProjectFeeDetailsByProjectId: (projectId: string): string =>
    `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/fee`,

  createInvoiceByProjectId(projectId: string): string {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/invoice`;
  },
  getProjectInvoiceById(invoiceId: string): string {
    return `${PROGRAM_BASE_URL}/projectInvoices/${invoiceId}`;
  },
  getInvoicesByProjectId(projectId: string): string {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/invoices`;
  },
  getProjectExpenseById(projectExpenseId: string): string {
    return `${PROGRAM_BASE_URL}/ProjectExpenses/${projectExpenseId}`;
  },
  getProjectFeesAndExpenseList(projectId: string): string {
    return `${PROGRAM_BASE_URL}/projects/${projectId}/expenses`;
  },
  createOrEditProjectFeeOrExpense(projectId: string): string {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/expense`;
  },
  getProjectExpense: (projectId: string): string => {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/expenses`;
  },
  getProjectFeeDetails: (projectId: string): string => {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/fee`;
  },
  getProjectInvoicingLanguages: (
    clientId?: string,
    projectId?: string,
  ): string => {
    if (isNotEmpty(clientId))
      return `${MDM_BASE_URL}/invoicingLanguages?clientId=${validateApiParamValue(clientId)}`;
    if (isNotEmpty(projectId))
      return `${MDM_BASE_URL}/invoicingLanguages?projectId=${validateApiParamValue(projectId)}`;
    return `${MDM_BASE_URL}/invoicingLanguages`;
  },
  getViewProjectDetailById(projectId: string): string {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/projectDetails`;
  },
  updateProjectFeeDetailsByProjectId(projectId: string): string {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/fee`;
  },
  createUpdateChildPrograms: (projectId: string): string => {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/childPrograms`;
  },
  getProjectDeliverables(projectId: string): string {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/deliverables`;
  },
  projectActivation: (projectId: string): string => {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/activation`;
  },
  getProjectStatusListById(projectId: string): string {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/projectStatus`;
  },
  saveProjectStatus(projectId: string): string {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/projectStatus`;
  },
  addExistingProjectDeliverable(projectId: string): string {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/cloneDeliverables`;
  },
  getProjectDeliverableById(deliverableId: string, projectId?: string): string {
    const baseUrl = `${PROGRAM_BASE_URL}/projectDeliverables/${validateApiParamValue(deliverableId)}`;
    return projectId
      ? `${baseUrl}?projectId=${validateApiParamValue(projectId)}`
      : baseUrl;
  },
  getTopicListByProjectId(projectId: string): string {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/topics`;
  },
  getProjectTopicById(topicId: string): string {
    return `${PROGRAM_BASE_URL}/projectTopics/${validateApiParamValue(topicId)}`;
  },
  getActivityTimelineById(timelineId: string): string {
    return `${PROGRAM_BASE_URL}/projectTimelineActivities/${validateApiParamValue(timelineId)}`;
  },

  restoreContractArchiveDocument(documentId: string): string {
    return `${CLIENT_MANAGEMENT}/contractDocuments/${documentId}/restore`;
  },

  restoreOtherArchiveDocument(documentId: string): string {
    return `${CLIENT_MANAGEMENT}/otherClientDocuments/${documentId}/restore`;
  },

  VALIDATE_OPPORTUNITY_ID: "mdm/opportunityDetails",

  getContractDocumentDropdown(params: GetContractDocumentPayload): string {
    const baseUrl = `${CLIENT_MANAGEMENT}/contractDocuments/GetContractDocumentDropdown`;
    return `${baseUrl}?clientid=${validateApiParamValue(params.clientId)}&productLineId=${validateApiParamValue(params.productLineId)}&Status=${validateApiParamValue(params.status)}&SortBy=${validateApiParamValue(params.sortBy)}`;
  },

  getPaymentTermByProgramId: (programId: string) => {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/paymentTerm`;
  },

  getGoalsListByProgramId: (programId: string) => {
    return `${PROGRAM_BASE_URL}/goals/${validateApiParamValue(programId)}/goals`;
  },
  addGoalByProgramId: (programId: string) => {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/goal`;
  },
  updateGoalById: (goalId: string) => {
    return `${PROGRAM_BASE_URL}/goals/${validateApiParamValue(goalId)}`;
  },
  getGoalDetailsById: (goalId: string) => {
    return `${PROGRAM_BASE_URL}/goals/${validateApiParamValue(goalId)}`;
  },
  deleteGoalById: (goalId: string) => {
    return `${PROGRAM_BASE_URL}/goals/${validateApiParamValue(goalId)}`;
  },

  GET_PROGRAM_TM_INDIVIDUAL_COACH_FUNCTION:
    MDM_BASE_URL + "/tmIndividualAssessmentJobFunctions",

  GET_PROGRAM_TM_LEADER_COACH_FUNCTION:
    MDM_BASE_URL + "/tmLeaderCoachJobFunctions",

  CREATE_NIS_PARTICIPANT: `${PROGRAM_BASE_URL}/nisparticipants`,
  GET_PROJECT_MANAGERS_FOR_NIS_PARTICIPANT: `${USERS_BASE_URL}/ProjectManagers`,
  getActivityTypeListForNIS(nisParticipantStatus: string): string {
    return `${PROGRAM_BASE_URL}/NISParticipants/activityTypes?NisParticipantStatus=${validateApiParamValue(nisParticipantStatus)}`;
  },
  getModalityListForNIS(activityTypeId: string): string {
    return `${PROGRAM_BASE_URL}/nisparticipants/${activityTypeId}/modalities`;
  },
  getTopicListForNIS(
    activityTypeId: string,
    nisParticipantStatus: string,
  ): string {
    return `${PROGRAM_BASE_URL}/nisparticipants/${activityTypeId}/topics?NisParticipantStatus=${validateApiParamValue(nisParticipantStatus)}`;
  },
  GET_CLIENT_LIST_BY_COUNTRY: (
    countryCode: string,
    isActiveClientOnly?: boolean,
  ) => {
    let urlParams = `countryCode=${validateApiParamValueWithBlankSpace(countryCode)}`;
    if (isActiveClientOnly) {
      urlParams = `${urlParams}&isActiveClient=${isActiveClientOnly}`;
    }
    return `${CLIENT_MANAGEMENT}/GetClientsList?${urlParams}`; // isActive client true.
  },
  getNISParticipantById: (nisParticipantId: string) => {
    return `${PROGRAM_BASE_URL}/NISParticipants/${validateApiParamValue(nisParticipantId)}`;
  },
  updateNISParticipantById: (nisParticipantId: string) => {
    return `${PROGRAM_BASE_URL}/NISParticipants/${validateApiParamValue(nisParticipantId)}`;
  },
  updateNISParticipantStatusById: (nisParticipantId: string) => {
    return `${PROGRAM_BASE_URL}/NISParticipants/${validateApiParamValue(nisParticipantId)}/status`;
  },
  getNISParticipantActivityTimelineById: (nisParticipantId: string) => {
    return `${PROGRAM_BASE_URL}/NISParticipants/${validateApiParamValue(nisParticipantId)}/activityTimeline`;
  },
  addNISParticipantActivityTimelineById: (nisParticipantId: string) => {
    return `${PROGRAM_BASE_URL}/NISParticipants/${validateApiParamValue(nisParticipantId)}/timelineActivity`;
  },
  updateNISParticipantActivityTimelineById: (timelineActivityId: string) => {
    return `${PROGRAM_BASE_URL}/nisTimelineActivities/${validateApiParamValue(timelineActivityId)}`;
  },
  getNISParticipantStatusById: (nisParticipantId: string) => {
    return `${PROGRAM_BASE_URL}/NISParticipants/${validateApiParamValue(nisParticipantId)}/status`;
  },
  programUploadDocumentsById(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/programDocuments`;
  },
  getProgramDocumentsList(programId: string): string {
    return `${PROGRAM_BASE_URL}/programs/${validateApiParamValue(programId)}/programDocuments`;
  },
  getProgramDocumentDetailsById(programDocumentId: string): string {
    return `${PROGRAM_BASE_URL}/programDocuments/${validateApiParamValue(programDocumentId)}`;
  },
  deleteProgramDocument(programDocumentId: string): string {
    return `${PROGRAM_BASE_URL}/programDocuments/${validateApiParamValue(programDocumentId)}`;
  },
  COACH_PORTAL: PROGRAM_BASE_URL + "/programs/coachportal",
  COACH_PORTAL_SEARCH: PROGRAM_BASE_URL + "/programs/coachportal/search",
  getSearchProgramsForProject(projectId: string): string {
    return `${PROGRAM_BASE_URL}/projects/${validateApiParamValue(projectId)}/programs`;
  },
  getClientSalesOffices(clientId: string): string {
    return `${CLIENT_MANAGEMENT}/clients/${validateApiParamValue(clientId)}/clientSalesOffices`;
  },
  GET_COACH_REPORT: `${PROGRAM_BASE_URL}/coachReport`,
  EXPORT_COACH_REPORT: `${PROGRAM_BASE_URL}/coachReport/export`,
  getBulkActivitiesResult(bulkImportId: string): string {
    return `${PROGRAM_BASE_URL}/bulk-activities-result/${validateApiParamValue(bulkImportId)}`;
  },
  getBulkTransferResult(bulkImportId: string): string {
    return `${PROGRAM_BASE_URL}/bulk-transfer-result/${validateApiParamValue(bulkImportId)}`;
  },
};
